import { createSlice } from "@reduxjs/toolkit";
import subscribedStudies from "../../../rtk-apis/subscription/subscribedStudies"

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const subscribedStudiesSlice = createSlice({
  name: "subscribedStudiesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(subscribedStudies.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(subscribedStudies.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(subscribedStudies.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default subscribedStudiesSlice.reducer;
